<template>
  <div class="product">
    <div class="banner_content">
      <img src="../assets/img/product/car/banner.png" width="648" height="183"/>
      <div class="div_font">
        <div class="div_1">
          <i class="font_1">汽车</i>
          <i class="font_2">智驭未来，安全同行</i>
        </div>
        <div class="div_2">
          高安全性与高可靠性并存，保证您的个人信息安全，让出行更舒心，做你生活中的智能管家。
        </div>
      </div>
    </div>
    <el-tabs v-model="activeName" @tab-click="tabClick" :stretch="true" class='custom-tabs'>
      <el-tab-pane label="汽车产品" name="service">
      </el-tab-pane>
    </el-tabs>
    <div class="detail_content">
      <div>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content" @click="itemClick(1)">
              <img src="../assets/img/product/car/p1.png" width="410" height="240" class="p_img"/>
              <div class="p_title"><span style="font-weight: bolder; background-color: #fff;">智能B柱</span></div>
            </div>
          </el-col>
          <el-col :span="8">

          </el-col>
          <el-col :span="8">

          </el-col>
        </el-row>

      </div>

    </div>
    <el-dialog
        :visible.sync="centerDialogVisible"
        width="80%"
        center>
      <div v-if="productIndex === 1" class="dialog_content">
        <img src="../assets/img/product/car/p1-1.png" width="395" height="395">
        <div class="right_content">
          <span class="dialog_title">智能B柱</span>
          智能B柱是一种智能化的车辆辅助系统，具有多种功能。它集成了人脸识别、车辆控制和安全保障等模块，能够实现快速、准确的车辆解锁、启动和停车位信息展示等功能。
          <br>
          <span class="dialog_item_title">主要特性： </span>
          · 硬件安全：我们的智能B柱硬件方案具备高度的可靠性和稳定性，能够抵御各种潜在的攻击和干扰，如电磁干扰、恶意信号等。同时，符合各个国家和地区的标准和规范，确保其安全性和合规性。
          <br>· 生物特征识别安全：具备高度的准确性和可靠性，防止误识别和非法入侵。采用多种生物特征识别技术的组合，提高识别准确率和安全性。同时对生物特征信息进行加密和保护，防止信息泄露和滥用。
          <br>· 保证用户隐私和权益：智能B柱涉及到用户的个人信息和车辆信息，我们采取严格的数据保护措施。同时，用户需要对智能B柱的使用进行授权和管理，防止个人信息被非法获取和使用。
          <br>· 显示自定义：屏幕UI显示内容可以由用户在多媒体触控屏或者手机APP上自由定义，如家人照片，风景、汽车、游戏、动漫、宠物等。
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data() {
    return {
      activeName: "service",
      centerDialogVisible: false,
      productIndex: 0
    };
  },
  created() {

  },
  methods: {
    tabClick(tab) {
      if (tab.name == 'product') {
        this.title = '机载设备';
      }
    },
    handleTabClick(value) {
      this.title = value;
    },
    itemClick(index) {
      this.productIndex = index;
      this.centerDialogVisible = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.product {
  width: 1240px;
  height: 100%;
  background-color: #fff;
}

.banner_content {
  position: relative;
  width: 1240px;
  height: 227px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 50px;

  img {
    position: absolute;
    left: 0px;
  }

  .div_font {
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 580px;
    width: 580px;

    .div_1 {
      display: flex;
      flex-direction: row;
      margin-top: 13px;
      align-items: flex-end;

      .font_1 {
        font-size: 64px;
        line-height: 64px;
        color: #000;
        font-weight: bolder;
        font-family: Source Han Sans CN;
        font-style: normal;
        letter-spacing: 5px;
      }

      .font_2 {
        font-size: 16px;
        color: #AEAEAE;
        margin-left: 10px;
        font-style: normal;
      }
    }

    .div_2 {
      margin-top: 20px;
      line-height: 180%;
      padding: 30px 40px;
      background-color: #00AFBC;
      color: #fff;
      width: 100%;
      min-height: 76px;
    }
  }
}

::v-deep .el-tabs__item {
  width: 650px; /* 根据需要自定义宽度 */
  text-align: center;
  padding: 0 20px;
  height: 40px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 40px;
  display: inline-block;
  list-style: none;
  font-size: 20px;
  font-weight: bolder;
  color: #303133;
  position: relative;
}

.custom-tabs ::v-deep .el-tabs__active-bar {
  width: 200px !important;
  position: absolute;
  bottom: 0;
  left: calc((100% - 200px) / 2);
  height: 2px;
  background-color: #00AFBC;
  z-index: 1;
}

::v-deep .el-radio-button__inner {
  border: 0px solid #DCDFE6;
}

::v-deep .el-radio-button .el-radio-button__inner {
  height: 40px;
  width: 164px;
  background-color: #F3F3F3;
  margin-right: 25px;
  border-left: 0px solid #F3F3F3;
  border-radius: 20px;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

::v-deep .el-radio-button:last-child .el-radio-button__inner {
  margin-right: 0px;
}

::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #FFF;
  background-color: #1F6CC4;
  border-color: #1F6CC4;
  -webkit-box-shadow: -1px 0 0 0 #1F6CC4;
  box-shadow: 0 0 0 0 #1F6CC4;
}

.detail_content {
  display: flex;
  flex-direction: column;
  margin-top: 50px;

  i {
    font-size: 30px;
    color: #000;
    font-weight: bolder;
    font-style: normal;
    font-family: Source Han Sans CN;
  }

  span {
    background-color: #1F6CC4;
    width: 100px;
    height: 5px;
  }

  .detail {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 30px 0 50px 0;

    .detail_title {
      display: flex;
      flex-direction: row;
      width: 1160px;
      height: 26px;
      line-height: 26px;
      margin-top: 40px;

      .title_img {
        vertical-align: middle;
        margin-right: 10px;
        margin-top: 4px;
      }

      i:first-child {
        font-size: 26px;
        color: #00338B;
        font-style: normal;
        font-family: Source Han Sans CN;
        font-weight: bolder;
        vertical-align: middle;
      }
    }

    .detail_font {
      font-size: 18px;
      margin-top: 30px;
      width: 1160px;
      line-height: 180%;
    }

    .main_pic {
      margin-top: 30px;
    }

    .detail7_img {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
}
.grid-content:hover {
  cursor: pointer;
}
.grid-content {
  display: flex;
  flex-direction: column;
  align-items: center;

  .p_img {
    border: 1px dotted #EBEBEB;
  }

  .p_title {
    font-size: 16px;
    color: #000;
    margin-top: 20px;
    margin-bottom: 50px;
  }
}
.grid-content-pma {
  position: relative;
  align-items: center;
  margin-top: 58px;

  .p_img {
    border: 1px dotted #EBEBEB;
  }

  .p_title {
    display: none;
    position: absolute;
    background-color: rgba(3, 0, 0, 0.61);
    bottom: -20px;
    font-size: 16px;
    color: #fff;
    line-height: 180%;
    padding: 10px;
    width: 392px;
  }
}

.grid-content-pma:hover .p_title {
  display: block;
}

.grid-content-pma:hover img {
  box-shadow: 0px 0px 10px blue;
}

.product-content {
  width: 1240px;
  margin: 0 auto;
  background-color: #fff;
}
.dialog_content {
  display: flex;
  flex-direction: row;
  .right_content {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    line-height: 200%;
    margin-left: 30px;
    width: 100%;
    .dialog_title {
      color: #00338B;
      font-size: 26px;
      font-weight: bolder;
      margin-bottom: 20px;
    }
    .dialog_item_title {
      font-weight: bolder;
      margin-top: 20px;
    }
  }
  .pz_title {
    background-color: #e3f2f9;
    font-weight: bolder;
    margin-bottom: 2px;
    margin-right: 2px;
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
  }
  .pz_value {
    background-color: #e3f2f9;
    height: 40px;
    line-height: 40px;
  }
}

::v-deep .el-dialog {
  border-radius: 10px;
}
</style>